"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/* eslint-disable global-require */
var _default = exports["default"] = {
  images: [],
  frames: [[0, 0, 420, 1160, 0, 0, 0]],
  animations: {
    PoseC: {
      speed: 1,
      frames: [0]
    },
    PoseB: {
      speed: 1,
      frames: [0]
    },
    PoseA: {
      speed: 1,
      frames: [0]
    },
    talkCycle: {
      speed: 1,
      frames: [0]
    },
    Idle: {
      speed: 1,
      frames: [0]
    }
  },
  framerate: 24
};